import {
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import {
  getCargosUsuarioSuccess,
  GET_CARGOS_USUARIO,
  BORRAR_CARGO,
} from '../../redux/actions/cargoActions';
import {
  ROUTE_CARGO_AUTOMATICO,
  ROUTE_NUCLEO,
  ROUTE_NOTIFICACION,
} from '../../utils/constants';
import toAPIPath from '../../utils/locationResolver';
import { buildPaymentAffiliationInternalNotificationEmail } from '../../utils/emailTemplates';

export function* loadCargos(payload) {
  const { api, userData } = payload;
  try {
    const user = yield call(api.get, toAPIPath([ROUTE_NUCLEO, `${userData.nucleo}?filter=${encodeURIComponent('{"include": [{"relation":"cargoAutomatico"}]}')}&access_token=${userData.token}`]));
    yield put(getCargosUsuarioSuccess(user.cargoAutomatico));
  } catch (err) {
    throw err;
  }
}

export function* deleteCargo(payload) {
  const { api, userData, id } = payload;
  try {
    // Obtener el cargo eliminado (incluye los alumnos directamente)
    const cargoEliminado = yield call(api.get, toAPIPath([ROUTE_CARGO_AUTOMATICO, `${id}?access_token=${userData.token}`]));

    // Eliminar el cargo
    yield call(api.delete, toAPIPath([ROUTE_CARGO_AUTOMATICO, `${id}?access_token=${userData.token}`]));

    // Recargar los cargos
    yield call(loadCargos, { api, userData });

    // Obtener datos de sesión para obtener el nombre del usuario que borra
    const appState = yield select(state => state.app);
    const usuario = appState.session.user.nombre;

    // Concatenar nombres de los alumnos del array cargoEliminado.alumno
    const concatenarNombreAlumno = (cargo) => cargo.alumno
      .map(a => `${a.nombreAlumno.trim()} ${a.apellido1} ${a.apellido2}`)
      .join(', ');

    // Construir la notificación
    const notificacion = buildPaymentAffiliationInternalNotificationEmail(
      concatenarNombreAlumno(cargoEliminado), // le paso un objeto con nombre concatenado
      'contabilidad@weizmancr.net, asistente.contable@weizmancr.net',
      usuario
    );

    // Enviar la notificación
    yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${userData.token}`]), notificacion);

  } catch (err) {
    throw err;
  }
}


export default function* rootSaga() {
  yield takeLatest(GET_CARGOS_USUARIO, loadCargos);
  yield takeLatest(BORRAR_CARGO, deleteCargo);
}
